import { NavigationGuard } from "vue-router"

const defaultTitle = window.document.title

export const metaTitleGuard: NavigationGuard = (to) => {
  window.document.title = <string>to.meta.metaTitle || defaultTitle
}
